import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import "./PaymentCallback.css";

export const PaymentSuccess = () => {
  const { refreshUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Refresh user data to pick up new subscription tier
    refreshUser();
  }, []);

  useEffect(() => {
    // Auto-redirect to dashboard after 5 seconds
    const timer = setTimeout(() => {
      navigate("/dashboard");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="payment-callback success">
      <div className="callback-card">
        <div className="success-icon">✓</div>
        <h1>Payment Successful!</h1>
        <p className="callback-message">
          Your subscription is active. Welcome aboard — your new plan features are ready to use.
        </p>
        <div className="callback-info">
          <p>✅ Payment confirmed</p>
          <p>✅ Subscription activated</p>
          <p>🔄 Redirecting to dashboard in 5 seconds...</p>
        </div>
        <div className="callback-actions">
          <button
            className="btn-primary"
            onClick={() => navigate("/dashboard")}
          >
            Go to Dashboard Now
          </button>
          <button
            className="btn-outline"
            onClick={() => navigate("/account/pricing")}
          >
            View Pricing
          </button>
        </div>
      </div>
    </div>
  );
};
